/**
 * formulaVersionsService.ts — API client for the FORMULA LEDGER
 * (Admin → Formula Versions; Tier 3A, CJ/Gigi 2026-07-30).
 * Backend: GET /api/admin/integrity/formula-versions (admin only), served
 * from the git-tracked backend/src/calculation/formulas/formulaChangelog.ts.
 */

import apiClient from './apiClient';

export interface FormulaChangeAuthor {
  name: string;
  kind: 'ai' | 'human';
  detail?: string;
}

export interface FormulaChange {
  columnKey: string;
  label: string;
  /** Absent for brand-new columns and the baseline snapshot. */
  before?: string;
  after: string;
  note?: string;
}

export interface FormulaChangeEntry {
  testTypeId: string;
  testTypeName: string;
  version: string;
  date: string;
  appliedBy: FormulaChangeAuthor;
  requestedBy?: string;
  context?: string;
  changes: FormulaChange[];
}

export interface FormulaTestTypeSummary {
  key: string;
  name: string;
  formulaCount: number;
  lastChanged: string | null;
  lastVersion: string | null;
  lastAppliedBy: FormulaChangeAuthor | null;
}

export interface RegistryFormula {
  columnKey: string;
  label: string;
  kind: 'calc' | 'raw';
  formula?: string;
  note?: string;
}

export interface FormulaVersionsLog {
  testTypes: FormulaTestTypeSummary[];
  history: FormulaChangeEntry[];
  /** The LIVE registry, keyed by test type — the formulas in force now. */
  registry: Record<string, RegistryFormula[]>;
}

export async function fetchFormulaVersions(): Promise<FormulaVersionsLog> {
  const response = await apiClient.get('/admin/integrity/formula-versions');
  return response.data;
}
